import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import OmOss from "./pages/OmOss";
import Konsultasjoner from "./pages/Konsultasjoner";
import KonsultasjonDetalj from "./pages/KonsultasjonDetalj";
import Seminarer from "./pages/Seminarer";
import SeminarDetalj from "./pages/SeminarDetalj";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-oss" element={<OmOss />} />
          <Route path="/konsultasjoner" element={<Konsultasjoner />} />
          <Route path="/konsultasjoner/:id" element={<KonsultasjonDetalj />} />
          <Route path="/seminarer" element={<Seminarer />} />
          <Route path="/seminarer/:id" element={<SeminarDetalj />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
